import { isString } from 'rev-shared/util';
import { BootstrapContext } from 'rev-shared/bootstrap/BootstrapContext';

export function parseBooleanQueryParam(param: string): boolean {
	return isString(param)
		? param.trim().toLowerCase() === 'true'
		: !!param;
}

export function getEmbedPlayerConfig(queryParams: any, isParseBool?: boolean) {
	return {
		playerControls: {
			overlayControls: isParseBool ? !parseBooleanQueryParam(queryParams.noCenterButtons) : !queryParams.noCenterButtons,
			playControls: isParseBool ? !parseBooleanQueryParam(queryParams.noPlayBar) : !queryParams.noPlayBar,
			cc: isParseBool ? !parseBooleanQueryParam(queryParams.noCc) : !queryParams.noCc,
			settings: isParseBool ? !parseBooleanQueryParam(queryParams.noSettings): !queryParams.noSettings,
			fullscreen: isParseBool ? !parseBooleanQueryParam(queryParams.noFullscreen) : !queryParams.noFullscreen,
			chapterSeek: isParseBool ? !parseBooleanQueryParam(queryParams.noChapterSeek) : !queryParams.noChapterSeek,
			chapterDisplay: isParseBool ? !parseBooleanQueryParam(queryParams.noChapterDisplay) : !queryParams.noChapterDisplay,
			chapterMenu: isParseBool ? !parseBooleanQueryParam(queryParams.noChapterMenu) : !queryParams.noChapterMenu
		},
		accentColor: queryParams.accent,
		forcedCCOn: isParseBool ? parseBooleanQueryParam(queryParams.forceClosedCaptions) : queryParams.forceClosedCaptions,
		subtitleLangPreferenceOrder: BootstrapContext.languagePreferenceOrder
			.map(lang => lang.toLowerCase())
	};
}
